module.exports = __webpack_public_path__ + "images/daciafb0db6de6700be106c5c0765081c1cac.png";